var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"icon",attrs:{"width":_setup.props.width || 21,"height":_setup.props.height || 21}},[_c('use',{attrs:{"xlink:href":"#___icon___infant-club"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }